import React, { useContext } from 'react';
import styled from '@emotion/styled';
import type { WCmsPhotoPageView } from '@zola/svc-web-api-ts-client';
import { ThemeContext } from '../../context';
// import CONTAINER_QUERY from '../../util/containerQuery';

type PhotosProps = {
  photosPageData?: WCmsPhotoPageView;
};

const Photos = ({ photosPageData }: PhotosProps): JSX.Element => {
  const { title, description, photos } = photosPageData || {};
  const {
    components: { H3, P },
  } = useContext(ThemeContext);

  // console.log(photosPageData);

  const PhotoContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: 50px;
  `;

  const Title = styled(H3)`
    margin-bottom: 12px;
  `;

  const Image = styled.img`
    width: 25%;
  `;

  return (
    <>
      <Title>{title}</Title>
      <P>{description}</P>
      <div className="testClass">
        <PhotoContainer>
          {photos?.map(p => (
            <Image src={p.image_url} />
          ))}
        </PhotoContainer>
      </div>
    </>
  );
};

export default Photos;
